module.exports = __webpack_public_path__ + "img/title-2.07642429.png";